<div class="sidebar-container">
  <div class="sidebar-container-top">
    <div class="company-logo">
      @let theme = (hubTheme$ | async);
      <app-svg-icon [icon]="'nessy-logo-' + theme"></app-svg-icon>
    </div>
    <div class="mobile-header">
      <button class="btn btn-toggle" (click)="toggleSidebar()">
        @if (showMobileNavigation) {
        <app-svg-icon [icon]="'icon-close'"></app-svg-icon>
        } @else {
        <app-svg-icon [icon]="'icon-menu'"></app-svg-icon>
        }
      </button>
    </div>
  </div>
  <div class="navigation" [class.open]="showMobileNavigation">
    <ul>
      @for (item of navItems; track $index) {
      <li>
        <button class="btn navigation-btn" [class]="{
              active: isActive(item.path) || activeMenu === item.path,
              hasChildren: item.subItems && item.subItems.length > 0,
            }" (click)="
              item.subItems?.length ? toggleMenu(item.path) : routeTo(item)
            ">
          <app-svg-icon [icon]="item.icon"></app-svg-icon>
          @if (item.badge) {
          <span class="nav-label-badged">
            {{ item.label }}
            <span class="nav-badge">{{ item.badge }}</span>
          </span>
          } @else {
          {{ item.label }}
          }
          @if (item.subItems && item.subItems.length > 0) {
          <app-svg-icon [icon]="
                  activeMenu === item.path
                    ? 'icon-chevron-up'
                    : 'icon-chevron-down'
                "></app-svg-icon>
          }
        </button>

        <!-- Submenu -->
        @if (item.subItems && item.subItems.length > 0) {
        <div class="collapse" [class.show]="activeMenu === item.path">
          <ul class="subnav-items">
            @for (child of item.subItems; track $index) {
            <li>
              <button class="btn navigation-btn" [class.active]="isActive(child.path)"
                (click)="routeTo(child)">
                @if (child.icon) {
                <app-svg-icon [icon]="child.icon"></app-svg-icon>
                }
                {{ child.label }}
              </button>
            </li>
            }
          </ul>
        </div>
        }
      </li>
      }
    </ul>

    <div class="bottom-sidebar">
      <app-user-panel></app-user-panel>
      <div class="logout">
        <app-svg-icon [icon]="'icon-logout'"></app-svg-icon>
        <button class="btn btn-blank" (click)="logout()">
          Log Out
        </button>
      </div>
    </div>
  </div>
</div>